import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { EMPTY, Observable, switchMap } from "rxjs";
import { MapDataService } from "src/services/map/map-data.service";

export const MunicipalityMapResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const mapDataService = inject(MapDataService);

    const lat = route.queryParams["lat"] as number;
    const lng = route.queryParams["lng"] as number;
    const municipality = route.queryParams["municipality"] as number;

    return mapDataService.getMunicipalityMapUrl(lat, lng, 15, municipality).pipe(
        switchMap((url) => {
            window.open(url, "_self");
            return EMPTY;
        }),
    );
};
